<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> {{bPresent ? 'دانش آموزان حاضر' : bStudentExam ?  'گزارش دانش آموزان حاضر در امتحان' : 'دانش آموزان غایب' }}  </span>

    </div>

</div>

<div dir="rtl" class="form w-100 row gx-2 px-2 gy-2 ">


    <div class="col-12 col-md-3">

        <form [formGroup]="dateFilter">

            <label> تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
            
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="strDate" class="form-control " />

            </ng-persian-datepicker>

        </form>

    </div>

   

    <div class="col-12 col-md-2 d-flex align-items-end  justify-content-end ">

        <button class="btn mx-md-2 px-5 btn-primary w-100 " type="button" (click)="search_student()">جستجو</button>

    </div>

</div>

<main class=" rtl px-2 mt-2 p-2">

    <span class="px-2" *ngIf="list_Absence.length > 0"> تعداد  <span class="text-danger fw-bold ">{{list_Absence.length | faNum}}</span>  مورد یافت شد </span>

    <div class="row gx-2 mt-2 border border-2 p-2">

        <div class="col-12 col-md-8 mt-3 mb-4">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_Absence.length > 0" class="col-12 col-md-4 mb-3 mb-md-0 d-flex align-items-center justify-content-end">

            <button class="btn btn-success mx-2" (click)="exportExcel()">
    
                <span> خروجی اکسل </span>
    
                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
    
            </button>
         
            <button *ngIf="!bPresent" class="btn btn-danger" (click)="message_Modal()" >
    
                <span> ارسال پیام </span>
    
                <i class="fa fa-envelope mx-2" aria-hidden="true"></i>
    
            </button>
    
    
        </div>

        <div class="table-responsive" style="max-height: 68vh;">

            <table class="table table-striped" id="Export_Excel">
    
                <thead class="position-sticky top-0 bg-white">
    
                    <tr class="col-12 text-center">

                        <th> # </th>

                        <th *ngIf="!bPresent" (click)="selectAllCheckBox()" class="pointer">انتخاب</th>

                        <th> تاریخ </th>

                        <th> روز </th>

                        <th> نام و نام خانوادگی </th>

                        <th *ngIf="!bPresent"> نام مدرسه </th>

                        <th> پایه </th>

                        <th *ngIf="!bPresent"> شماره موبایل </th>

                        <th *ngIf="bPresent"> ساعت ورود  </th>

                        <th *ngIf="bPresent"> ساعت خروج </th>

                    </tr>
    
                </thead>
    
                <tbody>
    
                    <tr class="col-12 text-center" *ngFor="let item of list_Absence;let i = index">
    
                        <th> {{ i + 1 | faNum }} </th>

                        <td *ngIf="!bPresent"><input type="checkbox" (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iPassenger)"></td>

                        <td>{{item.strDate | faNum}}</td>

                        <td>{{item.strDayName | faNum}}</td>

                        <td>{{item.strPassenger_FullName | faNum}}</td>

                        <td *ngIf="!bPresent">{{item.strMobileDomain_strComment}}</td>

                        <td>{{item.strGrade}}</td>

                        <td *ngIf="!bPresent">{{item.strMobile | faNum}}</td>

                        <td *ngIf="bPresent">{{item.strSTime | faNum}}</td>

                        <td *ngIf="bPresent">{{item.strETime | faNum}}</td>
    
                    </tr>
    
                </tbody>
    
            </table>
    
        </div>

    </div>



</main>

<div class="modal fade" id="sendMessage" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <form #message="ngForm" (ngSubmit)="sendMessage(message)" class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ارسال پیام </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class=" col-12 mb-2 p-2">

                <textarea dir="rtl" ngModel name="strMessage" class="form-control mb-2" cols="20" rows="7" placeholder="پیام خود را وارد کنید"></textarea>

                <div class="col-12 col-md-6">   

                    <input dir="rtl" type="checkbox" [ngModel]="false" name="bSendPush" class="mt-2" > ارسال پیام درون برنامه ای
                    
                </div>

                <div class="col-12 col-md-6">   

                    <input dir="rtl" type="checkbox" [ngModel]="false" name="bSaveMessage" class="mt-2" > ثبت پیام در کارتابل

                </div>


            </div>

            <div class="mb-2">

                <button class="btn mx-2 px-5 btn-primary" type="submit" > ارسال </button>

            </div>

        </form>

    </div>
</div>

<ng-container *ngIf="isLoading" >

    <div class="school_loading" style="z-index: 10000000000000000000000000000000000;">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>